import BookRow from "components/Bookcards/BookRow/BookRow";
import { LetterbookType } from "features/Letterbooks/types";

export default function LetterbookRow({
  letterbook,
}: {
  letterbook: LetterbookType;
}) {
  return (
    <div className="p-4 max-w-screen border-b border-gray-300 dark:border-gray-600">
      <BookRow size="sm" book={letterbook.book} edition={letterbook.edition} />
    </div>
  );
}
